var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFileupload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16675 2.00781C3.16675 0.903243 4.06218 0.0078125 5.16675 0.0078125H20.5196L29.8334 9.28288V30.0078C29.8334 31.1124 28.938 32.0078 27.8334 32.0078H5.16675C4.06218 32.0078 3.16675 31.1124 3.16675 30.0078V2.00781Z",
    fill: "#406EE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5105 0.0078125V8.27246C20.5105 8.82475 20.9582 9.27246 21.5105 9.27246H29.8334",
    fill: "#769DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6759 19.5587L16.4583 15.3828L12.3242 19.5587",
    stroke: "#F0F3F9",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4583 16.9663L16.4583 25.7391",
    stroke: "#F0F3F9",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileupload);
export default __webpack_public_path__ + "static/media/ic_fileupload.54c878debcc56dab9ede322586271b45.svg";
export { ForwardRef as ReactComponent };